<template>
<div class="paypage" >
    <!-- <topNav :title="title"></topNav> -->
    <div class="paypage-content">
        <div class="car-detail">
            <ul>
                <li><p>停车费用</p><h2>{{lastfee}}元</h2></li>
                <li><p>车牌号码</p><h2>{{carNum}}</h2></li>
            </ul>
        </div>
    </div>
    <div class="time-remaining">
        <p class="clear"><span class="left">已入场</span><span class="right">已出场</span></p>
        <div class="percent-container">
            <div class="percent-bg"><b></b><span id="percentBox"></span><b></b></div>
            <div class="percent-view"><b></b><span :style="'width:'+boxWidth+'px'"></span><b></b></div>
        </div>
        <p class="clear"><span class="left">{{dateIn}}</span><span class="right">-- --</span></p>
        <b class="car"></b>
    </div>
    <div class="pay_info">
        <p><span class="park_name">停车场</span><span class="park_value">{{parkingname}}</span></p>
        <p><span class="park_name">停车时长</span><span class="park_value">{{totalTime}}</span></p>
    </div>
    <div class="total_fee">
        <p><span class="park_name">停车费用</span><span class="park_value">{{totalfee}}元</span></p>
        <p><span class="park_name">已缴金额</span><span class="park_value">{{ historyfee  }}元</span></p>
        <p><span class="park_name">优惠金额</span><span class="park_value">{{ discfee }}元</span></p>
        <p><span class="park_name">本次应缴</span><span class="park_value">{{lastfee}}元</span></p>
    </div>
    
    <div class="module-box">
        <div class="popupdialog">
            <p>支付方式</p>
            <div :class="'bind_card '+bsType">
                <div v-for="(item,index) in payList" :key="index" :class="'pay-type-list '+item" @click.stop="changePayType(index)">
                    <div class="box">
                        <i class="icon"></i>
                        <p v-if="payItems.hasOwnProperty(item)">{{ payItems[item] }}</p>
                        <p v-if="item.indexOf('QR') != -1 && bsType=='wx'">微信支付</p>
                        <p v-if="item.indexOf('QR') != -1 && bsType=='al'">支付宝</p>
                        
                        <b :class="{active:payActiveIndex == index}"></b>
                    </div>
                </div>
            </div>
        </div>
        <p v-show="lockStatus == '0'" class="lock-box">该车辆处于锁定状态无法出场，点击<span @click="openWindow">立即解锁</span>解除锁定。</p>
        <div class="pay_btn" @click="confirm_pay">确认缴费</div>
        
        <p v-show="!showPic" class="ts">温馨提示：点击<span @click="showPic=true">显示图片</span>可查看入场车辆图片</p>
    </div>
    <div v-show="showPic" class="carpic">
        <img :src="carpic" alt="">
    </div>
    <div class="tt-dialog__wrapper" v-show="show">
        <div class="tt-dialog ">
            <img bind:src="images" v-lazy="images" alt="">
            <div class="tt_btn">
                <p class="refuse" @click="refuse()" ></p>
                <p class="accept" @click="accept()"></p>
            </div>
        </div>
    </div>
    <!-- 解锁弹窗开始 -->
    <div class="yzm-window"  v-show="showWindow">
        <div class="container">
            <h2>请输入手机号码进行验证<b @click="closeWindow"></b></h2>
            <div class="from-box">
                <p class="pnum">
                    <input type="text" v-model="phonenumber" name="" id="" placeholder="请输入手机号码" @blur="scrollRestore">
                </p>
                <p class="yzm">
                    <input type="number" v-model="verifycode" placeholder="请输入验证码" maxlength="6" @blur="scrollRestore">
                    <span v-show="!disabledBtn" @click="getAuthCode">获取验证码</span>
                    <span v-show="disabledBtn" class="txt">{{time}}</span>
                </p>
            </div>
            <div class="confirm-btn" @click="lockCar">确认解锁</div>
        </div>
    </div>
    <!-- 解锁弹窗结束 -->
    <div id="myFrom" v-html="myHtml" style="display:none;background:#ddd;height:100px;width:100%"></div>
    <!-- 广告模块 -->
    <!-- <div class="ads-container parkingpay-ads" v-if="WX_H5_POSC.imageUrl">
        <div class="ads-wrapper" @click="routeToAdsPage(WX_H5_POSC)">
        <div class="ads-cover"></div>
        <span class="ads-flag">广告</span>
        <van-icon class="ads-close" name="cross" size="22px" color="red" @click="handleCloseAd(WX_H5_POSC)" />
        <img :src="WX_H5_POSC.imageUrl" alt="">
        </div>
    </div> -->
</div>

</template>
<script>
import topNav from "../topnav/topnav"
import {DETAIL as API, AD_URL } from "@/assets/api"
import { Icon } from 'vant'
export default {
    name: 'paydetail',
    components:{
        topNav,
        [Icon.name]: Icon,
    },
    data() {
        return {
            title:"临时缴费",
            myHtml:"",//支付返回的html
            boxWidth:0,
            boxMaxWidth:0,
            activeTime:0,
            showPic:false,//是否显示车辆图片
            payList:[],//支付方式
            payActiveIndex:0,//当前选中支付方式的下标
            payItems: { // 显示支付方式
                'WX': '微信支付',
                'AL': '支付宝',
                'CCB': '建设银行',
                'BOC': '中国银行',
                'ICBC': '工商银行',
                'UNION': '银联支付',
                'CMBC': '招商银行',
                'HUZB': '湖州银行',
                'SCRCB': '四川农商银行',
                'BOCWISDOM': '中行智慧付',
                'JNRCB': '济南农商银行',
                'LUZB': '泸州银行',
                'ABC': '中国农业银行',
            },
            payChannelList: { // 确认支付可用支付方式
                CCBQR: { payway: 'CCBQRPAY', label: '建行聚合支付' },
                ICBCQR: { payway: 'ICBCQRPAY', label: '工商银行支付' },
                CCB: { payway: 'CCBPAY', label: '建行支付' },
                UNIONQR: { payway: 'UNIONQRPAY', label: '银联聚合支付' },
                HUZBQR: { payway: 'HUZBQRPAY', label: '聚合支付' },
                SCRCBQR: { payway: 'SCRCBQRPAY', label: '四川农商聚合支付' },
                BOCWISDOMQR: { payway: 'BOCWISDOMQRPAY', label: '中行智慧付' },
                CMBCQR: { payway: 'CMBCQRPAY', label: '招商支付' },
                JNRCBQR: { payway: 'JNRCBQRPAY', label: '济南农商银行' },
                LUZBQR: { payway: 'LUZBQRPAY', label: '泸州银行' },
                ABCQR: { payway: 'ABCQRPAY', label: '农行' },
                BOCQR: { payway: 'BOCQRPAY', label: '中行聚合支付', isDiff: true, WX: 'BOCWXPay', AL: 'BOCALPay' },
            },
            carNum:"",//显示的车牌号
            parkingname:"",//车场名称
            dateIn:"",//入场时间
            totalTime:"",//停车总时长
            totalfee:"",//总金额
            lastfee:"",//本次应缴金额
            carpic:require("../../../static/images/carpic.png"),//车辆图片
            images:require("../../../static/images/popup.png"),
            discfee:"",//优惠金额
            historyfee:"",//已缴金额
            bsType:"",//浏览器类型
            show:false,//无感支付窗口显示隐藏

            showWindow:false,//显示解锁弹窗
            phonenumber:"",//接受验证码的手机号
            verifycode:"",//验证码
            myTimer:null,//验证码定时器
            time:60,//验证码倒计时
            disabledBtn:false,//警用获取验证码按钮
            id:"",//社区id
            lockStatus:1,//
            disabledClick:false,//防止暴力点击
            clickTimer:null,
            
      
            ads: ['WX_H5_POSC'],
            WX_H5_POSC: {
                apiUrl: AD_URL + '?bCommid=00000165&ads=WX_H5_POSC',
                type: 'WX_H5_POSC',
                browserType: 'wx',
                adUrl: '',
                imageUrl: '',
            },
        }
    },
    mounted(){
        this.bsType = this.$store.state.browserType;
        this.getPayInfo();
        this.showPayWay();

        this.boxMaxWidth =  document.getElementById("percentBox").clientWidth;
        this.boxWidth = this.boxMaxWidth*0.5+2.5;

        // this.ads.forEach(el => {
        //     this.commonUtil.getAds(this[el])
        // });
    },
    methods:{
        changePayType(index){//
            this.payActiveIndex = index;
        },
        //支付信息获取
        getPayInfo(){
            this.carNum=this.commonUtil.getCookie("carNum2");
            this.parkingname=this.commonUtil.getCookie("parkingname");
            this.dateIn=this.commonUtil.getCookie("dateIn");
            this.totalTime=this.commonUtil.getCookie("totalTime");
            this.totalfee=this.commonUtil.getCookie("totalfee");
            var appid=sessionStorage.getItem("appid");//获取下单appid，从查询中获取的
            var inurl=this.commonUtil.getCookie("inurl");
            this.lastfee = this.commonUtil.getCookie("lastfee");
            this.id = this.commonUtil.getCookie("id");
            this.lockStatus = this.commonUtil.getCookie("lockStatus");
            
            if( !this.commonUtil.getCookie("discfee") || this.commonUtil.getCookie("discfee") == "0.00" ){
                this.discfee = "0.00"
            }else{
                this.discfee = "-" + this.commonUtil.getCookie("discfee")
            }
            if( !this.commonUtil.getCookie("historyfee") || this.commonUtil.getCookie("historyfee") == "0.00" ){
                this.historyfee = "0.00"
            }else{
                this.historyfee = "-" + this.commonUtil.getCookie("historyfee")
            }

            if(this.commonUtil.isEmpty(this.parkingname)){
                this.parkingname="暂无停车场"
            }
            if(!this.commonUtil.isEmpty(inurl))
            {
                this.carpic=inurl
            }
            if (this.commonUtil.browserType() == "wx") {
                if(!this.commonUtil.getUrlKey("originalId")){//originalId为空说明是还没进行过第二次回调
                    var data = JSON.parse(sessionStorage.getItem("payList"));
                    if(data){
                        data = data.join(",")//支持支付方式的支付串
                        if(data.indexOf("QR")!=-1 || data.indexOf("WX")!=-1){//微信支付或者聚合支付才进行第二次回调
                            this.commonUtil.wxopenid(appid);
                        }
                    }
                }
            }
        },
        //支付方式显示
        showPayWay(){
            var list = [];
            var myList = [];
            var data = sessionStorage.getItem("payList");
            if(data){
                myList=JSON.parse(data)
            }
            
            if(this.bsType == "wx"){//微信中删掉支付宝支付
                // // 隐藏 payItems 非微信的支付方式, 以及包含 WX 支付的各行QR聚合支付方式(采用微信支付或者无微信支付时qr聚合支付)
                var hasWXPay = myList.indexOf("WX") != -1;
                list = myList.filter(key=>{
                    if(this.payItems.hasOwnProperty(key) && key != 'WX') return false
                    else if(hasWXPay && key.indexOf('QR') != -1) return false
                    else return true
                })
            }else if(this.bsType=="al"){//支付宝中删掉微信支付
                // 隐藏 payItems 非微信的支付方式, 以及包含 AL 支付的各行QR聚合支付方式(采用微信支付或者无微信支付时qr聚合支付)
                var hasWXPay = myList.join(",").indexOf("AL") != -1;
                list = myList.filter(key=>{
                    if(this.payItems.hasOwnProperty(key) && key != 'AL') return false
                    else if(hasWXPay && key.indexOf('QR') != -1) return false
                    else return true
                })
            }
            this.payList = list.length && [list[0]]; //多个qr支付显示第一个
        },
        //确认支付
        confirm_pay(){
            if(this.disabledClick){
                return;
            }else{
                this.disabledClick = true;
                this.clickTimer = setTimeout(() => {
                    this.disabledClick = false;
                    clearTimeout(this.clickTimer);
                    this.clickTimer = null;
                }, 1000);
            }
            var payStr = this.payList[this.payActiveIndex];//当前选中的支付方式
            if(!payStr){
                this.$toast("请选择支付方式")
            }
            if(payStr=="UNION"){
                this.$toast("敬请期待")
            }
            if(payStr == "WX"){
                var openid=this.commonUtil.getUrlKey("originalId")
                if(!this.commonUtil.isEmpty(openid)){
                    this.commonUtil.wxPay(this.carNum);//微信支付 
                }else{
                    this.$toast("请重试")
                }
            }else if(payStr == "AL"){
                this.commonUtil.aliPay(this.carNum);//支付宝支付
            }else{
                if(this.payChannelList.hasOwnProperty(payStr)){
                    if(this.payChannelList[payStr].isDiff){
                        if(this.bsType == 'wx'){
                            this.commonUtil.wxPay(this.carNum, this.payChannelList[payStr].WX)
                        }
                        if(this.bsType == 'al'){
                            this.commonUtil.aliPay(this.carNum, this.payChannelList[payStr].AL)
                        }
                    }else{
                        this.commonUtil.bankPay(this.carNum, this.payChannelList[payStr].payway)
                    }
                }
                // if(payStr=="CCBQR"){
                //     this.commonUtil.bankPay(this.carNum,"CCBQRPAY");//建行聚合支付
                // }
                // if(payStr=="ICBCQR"){
                //     this.commonUtil.bankPay(this.carNum,"ICBCQRPAY");//工商银行支付
                // }
                // if(payStr == "CCB"){
                //     this.commonUtil.bankPay(this.carNum,"CCBPAY");//建行支付
                // }
                // if(payStr=="UNIONQR"){
                //     this.commonUtil.bankPay(this.carNum,"UNIONQRPAY");//聚合支付
                // }
                // if(payStr=="HUZBQR"){
                //     this.commonUtil.bankPay(this.carNum,"HUZBQRPAY");//聚合支付
                // }
                // if(payStr=="SCRCBQR"){
                //     this.commonUtil.bankPay(this.carNum,"SCRCBQRPAY");//四川农商聚合支付
                // }
                // if(payStr=="BOCWISDOMQR"){
                //     this.commonUtil.bankPay(this.carNum,"BOCWISDOMQRPAY");//中行智慧付
                // }
                // if(payStr=="CMBCQR"){
                //     this.commonUtil.bankPay(this.carNum,"CMBCQRPAY");//招商支付
                // }
                // if(payStr=="JNRCBQR"){
                //     this.commonUtil.bankPay(this.carNum,"JNRCBQRPAY");//济南农商银行
                // }
                // if(payStr=="ABCQR"){
                //     this.commonUtil.bankPay(this.carNum,"ABCQRPAY");//农行
                // }
                // if(this.bsType == "wx"){
                //     if(payStr=="BOCQR"){
                //         this.commonUtil.wxPay(this.carNum,"BOCWXPay");//中行聚合微信支付
                //     }
                // }
                // if(this.bsType=="al"){
                //     if(payStr=="BOCQR"){
                //         this.commonUtil.aliPay(this.carNum,"BOCALPay");//中行聚合支付宝支付
                //     }
                // }
            }
        },
        openWindow(){//打开验证码弹窗
            this.showWindow = true;
            var startTime = sessionStorage.getItem("code_time");
            if(startTime){
                var time = parseInt((new Date().getTime() - startTime)/1000);
                if(time < 60){
                    this.disabledBtn = true;
                    this.time = 60-time;
                    if(this.myTimer){
                        clearInterval(this.myTimer);
                        this.myTimer = null;
                    }
                    this.myTimer = setInterval(()=>{
                        if(this.time > 0){
                            this.time--;
                        }else{
                            this.time = 60;
                            this.disabledBtn = false;
                            clearInterval(this.myTimer);
                            this.myTimer = null;
                        }
                    },1000);
                }
            }
        },
        scrollRestore(){//页面滚动条复位
            //document.body.scrollTop = 0;
            setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100);
        },
        closeWindow(){//关闭验证码弹窗
            this.showWindow = false;
            this.phonenumber = "";
            this.verifycode = "";
        },
        getAuthCode(){//获取验证码
            if(!this.phonenumber){
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入手机号'
                });
                return;
            }
            if(!/^[0-9]{11}$/.test(this.phonenumber)){
                this.$dialog.alert({
                    title: '提示',
                    message: '手机号格式错误'
                });
                return;
            }
            sessionStorage.setItem("code_time",new Date().getTime());
            this.disabledBtn = true;
            if(this.myTimer){
                clearInterval(this.myTimer);
                this.myTimer = null;
            }
            this.myTimer = setInterval(()=>{
                if(this.time > 0){
                    this.time--;
                }else{
                    this.time = 60;
                    this.disabledBtn = false;
                    clearInterval(this.myTimer);
                    this.myTimer = null;
                }
            },1000);
            var originalId = sessionStorage.getItem("originalId");
            var req = {
                phonenumber:this.phonenumber,
                originalId,
                //originalId:"o0b1TwS4YYKnaqay_Adx8xoqxHxo"
            }
            
            this.$http({
                method: 'post',
                url: API.GET_AUTH_CODE,
                data: this.qs.stringify(req),
                success: function(data){
                    if(data.code == 0){
                        this.$toast({
                            duration: 1200,
                            message:"获取验证码成功"
                        });
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
        lockCar(){//解锁车辆
            if(!this.verifycode){
                 this.$dialog.alert({
                    title: '提示',
                    message: '验证码不能为空'
                });
                return;
            }
            if(this.verifycode.lenghth <6){
                 this.$dialog.alert({
                    title: '提示',
                    message: '格式错误'
                });  
                return;  
            }
            if(!this.phonenumber){
                 this.$dialog.alert({
                    title: '提示',
                    message: '手机号不能为空'
                });
                return;
            }
            if(!/^[0-9]{11}$/.test(this.phonenumber)){
                this.$dialog.alert({
                    title: '提示',
                    message: '手机号格式错误'
                });
                return;
            }
            var originalId = sessionStorage.getItem("originalId");
            var req = {
                lockmode:1,//1：解锁  0：锁定
                id:this.id,
                verifycode:this.verifycode,//验证码
                vehicleno:this.carNum,
                phonenumber:this.phonenumber,
                originalId,
                //originalId:"o0b1TwS4YYKnaqay_Adx8xoqxHxo"
            }
            
            this.$http({
                method: 'post',
                url: API.LOCK_CAR,
                data: this.qs.stringify(req),
                success: function(data){
                    if(data.code == 0){
                        // data = data.data;
                        // this.lockStatus = data.lock;
                        this.$toast({
                            duration: 1200,
                            message: data.msg
                        });
                        this.closeWindow()
                        //this.searchLockStatus();
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        });
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
        routeToAdsPage(ad, index){
            this.commonUtil.routeToAdsPage(ad, index)
        },
        handleCloseAd(ad){
            ad.adUrl = ''
            ad.imageUrl = ''
        },
    },
    watch:{
        "$store.state.payHtml"(value){
            if(value){
                var html = value;
                this.$store.state.payHtml = "";
                this.myHtml = html;
                //当dom发生更新，更新结束后回调
                this.$nextTick().then(() => {
                    document.forms[0].submit();
                })
            }
        }
    }

}
</script>
<style lang="css" scoped>
@import "../../../static/css/parkingPay.css";
</style>
<style lang="less" scoped>
    @keyframes fadeIn {
        0% {
            opacity: 0;
            transform: translate(0, 20px);
        }
        100% {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
    .ads-container{
        .ads-wrapper{
            margin: 0 auto;
            position: relative;
            
            animation-name: fadeIn;
            animation-duration: 1.5s;
            animation-timing-function: ease-in-out;
            animation-fill-mode: forwards;
            opacity: 0;
            img{
                display: block;
                max-width: 100%;
            }
            .ads-cover{
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.1);
            }
            .ads-flag{
                display: block;
                font-weight: bold;
                color: #ff0000;
                font-size: 14px;
                line-height: 18px;
                position: absolute;
                left: 0;
                top: 0;
            }
            .ads-close{
                position: absolute;
                right: 0;
                top: 0;
            }
        }
        &.parkingpay-ads{
            padding-top: 30px;
            .ads-wrapper{
                width: 70%;
                img{
                    display: block;
                    max-width: 100%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/paydetail/parkingpay2.vue